import React from 'react';
import { PRIMARY } from '../../../../theme';
export var Envelope = function Envelope(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "26",
    height: "25",
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06981 6C4.90707 6.00002 4.751 6.06851 4.63592 6.1904C4.52085 6.3123 4.45619 6.47761 4.45618 6.65V18.35C4.45619 18.5224 4.52085 18.6877 4.63592 18.8096C4.751 18.9315 4.90707 19 5.06981 19H21.8425C22.0053 19 22.1614 18.9315 22.2764 18.8096C22.3915 18.6877 22.4562 18.5224 22.4562 18.35V6.65C22.4562 6.47761 22.3915 6.3123 22.2764 6.1904C22.1614 6.06851 22.0053 6.00002 21.8425 6H5.06981ZM6.80845 7.3H20.1039L13.4562 12.9672L6.80845 7.3ZM5.68345 8.00417L13.0727 14.301C13.1815 14.3933 13.3168 14.4436 13.4562 14.4436C13.5956 14.4436 13.7309 14.3933 13.8397 14.301L21.2289 8.00417V17.7H5.68345V8.00417Z",
    fill: props.color || PRIMARY
  }));
};